export default "__VITE_ASSET__a6d6daed__"